import React, { useEffect, useState } from 'react';
import { useAuth } from '../../Context/AuthContext';
import axios from 'axios';
import QuizScoreCard from './QuizScoreCard';
import QuizCard from './QuizCard';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { getAuthToken } from '../Helpers/script';

const ModalConfirmation = ({
  userResponses,
  totalQuestions,
  handleVisiblity,
  isVisible,
  setScoreCardMetrics,
}) => {
  const [isloading, setIsLoading] = useState(false);

  const { currentUser } = useAuth();

  const handleSave = async () => {
    setIsLoading(true);

    try {
      const token = await getAuthToken(currentUser);
      const urlParams = new URLSearchParams(window.location.search);
      const quizID = urlParams.get('id');
      const courseName = urlParams.get('courseName');

      const payload = {
        responses: userResponses,
        quizID,
        courseName,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL ?? ''}/api/saveResponses`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const { score, answers } = response.data;
        setScoreCardMetrics({ score, answers });
        setIsLoading(false);
        handleVisiblity(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal isOpen={isVisible} onClose={() => handleVisiblity(false)}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Submit the Quiz</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure you want to submit?</Text>

          {Object.keys(userResponses).length !== totalQuestions && (
            <Text>
              You have answered {Object.keys(userResponses).length} /{' '}
              {totalQuestions}
            </Text>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            isLoading={isloading}
            loadingText="Subitting"
            colorScheme="blue"
            mr={3}
            onClick={handleSave}
          >
            Submit
          </Button>
          <Button onClick={() => handleVisiblity(false)}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const TestMeMode = () => {
  const { currentUser, setTopLevelError } = useAuth();
  const [user, setUser] = useState(null);

  const [quizQuestions, setQuizQuestions] = useState([]);
  const [userResponses, setUserResponses] = useState({});
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizScore, setQuizScore] = useState(null);

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [handleVisiblity, setHandleVisiblity] = useState(false);

  const handleQuestionIndex = operation => {
    if (operation === 'next') {
      if (currentQuestionIndex === quizQuestions.length - 1) {
        setHandleVisiblity(true);
        return;
      }

      setCurrentQuestionIndex(prev => {
        if (prev === quizQuestions.length - 1) {
          return prev;
        }

        return prev + 1;
      });
    } else {
      setCurrentQuestionIndex(prev => {
        if (prev === 0) {
          return prev;
        }

        return prev - 1;
      });
    }
  };

  const handleScoreCardMetrics = ({ score, answers }) => {
    setQuizScore(score);
    setQuizAnswers(answers);
  };

  useEffect(() => {
    if (currentUser && !user) {
      setUser(currentUser);
    }
  }, [currentUser, user]);

  useEffect(() => {
    const retrieveQuiz = async () => {
      if (!user) return;
      const urlParams = new URLSearchParams(window.location.search);
      const quizID = urlParams.get('id');
      const courseName = urlParams.get('courseName');

      const payload = {
        quizID,
        courseName,
      };

      try {
        const token = await getAuthToken(user);

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL ?? ''}/api/retrieveQuiz`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const { questions, score, answers, userResponses } = response.data;

          setQuizQuestions(questions);
          if (typeof score === 'number') {
            handleScoreCardMetrics({ score, answers });
            setUserResponses(userResponses);
          }
        }
      } catch (err) {
        setTopLevelError("Couldn't retrieve the quiz! Please refresh the page");
      }
    };

    retrieveQuiz();
  }, [user, setTopLevelError]);

  return (
    <>
      {quizAnswers && Object.keys(quizAnswers).length > 0 ? (
        <QuizScoreCard
          score={quizScore}
          quizAnswers={quizAnswers}
          quizQuestions={quizQuestions}
          userResponses={userResponses}
        />
      ) : (
        <>
          <QuizCard
            id={quizQuestions[currentQuestionIndex]?.key}
            index={currentQuestionIndex}
            question={quizQuestions[currentQuestionIndex]}
            answer={quizAnswers[quizQuestions[currentQuestionIndex]?.key]}
            handleQuestionIndex={handleQuestionIndex}
            totalQuestions={quizQuestions.length}
            userResponses={userResponses}
            handleSaveResponse={setUserResponses}
          />
          <ModalConfirmation
            userResponses={userResponses}
            totalQuestions={quizQuestions.length}
            handleVisiblity={setHandleVisiblity}
            isVisible={handleVisiblity}
            setScoreCardMetrics={handleScoreCardMetrics}
          />
        </>
      )}
    </>
  );
};

export default TestMeMode;
